import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class District {
  id: number;
  code: number;
  subcity_id: number;
  name: string;
  route: number;
  km: number;
  hidden: number;
}

export class CreateDistrictDto {
  code: number;
  subcity_id: number;
  name: string;
  route: number;
  km: number;
  hidden: number;
}

export class UpdateDistrictDto {
  code?: number;
  subcity_id?: number;
  name?: string;
  route?: number;
  km?: number;
  hidden?: number;
}

export class DistrictFilterDto extends IQueryPaginationDto {
  code?: number;
  name?: string;
  subcity_id?: number;
}

export class DistrictResultsDto extends IPagination {
  @Type(() => District)
  results: District[];
}

export class DistrictResponseDto {
  @Type(() => District)
  result: District;
}
